import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Footer from '../components/footer';
import backgroundImage from '../assets/background.png';
import '../css/pages_styles.css';

const Registration = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [sidebarExpanded, setSidebarExpanded] = useState(true);

    // 偵測螢幕大小
    useEffect(() => {
        const checkScreenSize = () => {
            const width = window.innerWidth;
            setIsMobile(width <= 768);
        };

        // 初始檢查
        checkScreenSize();

        // 監聽視窗大小變化
        window.addEventListener('resize', checkScreenSize);
        
        // 清理事件監聽器
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // 監聽 sidebar 狀態變化的函數
    const handleSidebarToggle = (isExpanded) => {
        setSidebarExpanded(isExpanded);
    };

    return (
        <div style={{ display: 'flex', position: 'relative' }}>
            <Sidebar onToggle={handleSidebarToggle} />
            <div 
                className="main-content"
                style={{
                    marginLeft: isMobile ? '0' : (sidebarExpanded ? '250px' : '0')
                }}
            >
                <div className="container">
                    <header 
                        className="header"
                        style={{backgroundImage: `url(${backgroundImage})`}}
                    >
                        <h1 className="title">大會註冊</h1>
                    </header>
                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>
                        <h2 className="subtitle">註冊說明<span className="red-text">(註冊程序請見下方)</span></h2>
                        <p className="section-text red-text">註冊已開放</p>
                        <ul className="list">
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>每篇論文至少需有一名作者全額註冊。</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>
                                全額註冊費 (發表論文)-包含: 名牌、大會資訊、紀念品、午餐券及晚宴券一張: NTD 3,500。
                                <ul className="sub-list">
                                    <li className={`sub-list-item ${isMobile ? 'sub-list-item-mobile' : ''}`}>全額註冊費已包含一篇論文發表。若同一作者 (以投稿系統登錄帳號為準) 發表額外論文，每篇加收 $2,500元。</li>
                                    <li className={`sub-list-item ${isMobile ? 'sub-list-item-mobile' : ''}`}>舉例: M教授團隊投稿了三篇論文，則可以M教授作為代表註冊3篇論文，註冊費用為 3500+2500+2500=8500。</li>
                                </ul>
                            </li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>全額無發表論文註冊費- 包含: 名牌、大會資訊、紀念品、午餐券及晚宴券一張: NTD 3,500。</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>
                                學生註冊費- 包含: 名牌、大會資訊及午餐券 <span className="red-text">(晚宴券需另購)</span> (註冊時請上傳證明文件): NTD 2,000。
                                <ul className="sub-list">
                                    <li className={`sub-list-item ${isMobile ? 'sub-list-item-mobile' : ''}`}>請依註冊系統說明上傳學生證正反面照片(含應屆畢業生) 進行審核。若學生證審核未通過，主辦單位將視為全額註冊。</li>
                                </ul>
                            </li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>加購8/25午餐券，每位費用150元/人。</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>加購8/25晚宴券，每位費用1000元/人。</li>
                        </ul>

                        <h2 className="subtitle">註冊程序</h2>
                        <p className="section-text red-text">請至以下註冊連結完成註冊</p>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>
                                註冊連結: 
                                <a 
                                    href="https://mcwasn2025-esunbank.taai.org.tw" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="link">
                                    請點我
                                </a>
                            </li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>學生註冊，請於繳費之前上傳學生正反面照片供審查。</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>繳費: 於註冊系統中以信用卡繳費。請保留繳費憑證供日後存查。</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>展示海報請依照大會規定之格式與尺寸印製，並於會議當日攜帶至會場展示。</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>若未在指定時間內完成繳費註冊，請於會議當日至大會報到處現場補繳相關費用，為利日後寄送註冊費收據將酌收 $50元掛號郵寄費。</li>
                    </section>
                    <Footer/>
                </div>
            </div>
        </div>
    );
};

export default Registration;